import { ReactNode, useEffect } from 'react';
import { SRS } from '@datum-group/isogd-openapi/lib/models/srs';
import { registerProjection } from '@datum-group/datum-map/lib';
import { services } from '@project/API';

export interface ProjectionActivatorProps {
  children: ReactNode;
}

export const ProjectionActivator = ({ children }: ProjectionActivatorProps) => {
  useEffect(() => {
    let isUnmounted = false;

    (async () => {
      try {
        const response = await services.srs.apiSrsActive(undefined, 0);

        if (isUnmounted) return;

        response.data.results.forEach((srs) => {
          if (registeredSrid.has(srs.srid)) return;

          registerProjection(normalizeSrs(srs));
          registeredSrid.add(srs.srid);
        });
      } catch (error) {
        console.error('Не удалось зарегистрировать проекции карты', error);
      }
    })();

    return () => {
      isUnmounted = true;
    };
  }, []);

  return <>{children}</>;
};

const registeredSrid = new Set<number>();

const normalizeSrs = (srs: SRS): Parameters<typeof registerProjection>[0] => ({
  ...srs,
  extent: validateExtent(srs.extent),
  wgs84_extent: validateExtent(srs.wgs84_extent),
});

const validateExtent = (
  extent?: string | number[],
): [number, number, number, number] | undefined => {
  if (!extent) return undefined;

  if (typeof extent === 'string') return undefined;

  if (isExtent(extent)) return extent;

  return undefined;
};

const isExtent = (
  extent: number[],
): extent is [number, number, number, number] => {
  return (
    Array.isArray(extent) &&
    extent.length === 4 &&
    extent.every((value) => typeof value === 'number' && Number.isFinite(value))
  );
};
